// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3u6yr","header":"PatientBlock_header__2gYel","label":"PatientBlock_label__3a6oX","option":"PatientBlock_option__1vdyV"};